<template>
  <div id="diagnostic-list">
    <header class="header">
      <div class="title">
        <h1>Permisos de usuario.</h1>
      </div>

    </header>

    <div class="controls">
      <router-link :to="{
        name: 'New Synchronization',
      
      }">
       <button  type=" button" class="btn control upload-btn">+ AGREGAR USUARIO</button>
      </router-link>
      
    </div>


    <v-client-table :columns="table_options.columns" :options="table_options.options" :data="newsList">

      <template v-slot:actions="props">
        <div class="actions">

          <i @click="openEditModal(props)" class=" mr-4 icons-black far fa-edit"></i>
          <span
              class="icons-black"
              @click="openModal(props)"
            >
              <i class="far fa-eye"></i>
            </span>
        </div>
      </template>
    </v-client-table>

    <Modal v-if="newModalActive" v-on:closeModal="closeModal">
      <div v-if="error">
            <b-alert
              v-model="error"
              variant="danger"
              dismissible
              id="alert-modal"
            >{{ textoError }}</b-alert>
      </div>
      <!-- Modal title -->
      <template #header>
        <span class="title">{{ $t("diagnostic.category.edit") }}</span>
      </template>
      <!-- Modal body -->
      <template>
        <div class="form-container">
          <!-- Name -->
          <div class="input-container">
            <label for="name">{{ $t("diagnostic.category.name") }}</label>
            <input type="text" id="name" name="name" v-model="nameEdit">
            <div class="error-msg">
            </div>
          </div>

        </div>
      </template>
      <!-- Modal footer -->
      <template #footer>
        <div class="modal-actions">
          <span class="cancel-btn" @click="newModalActive=false">{{ $t("global.cancel") }}</span>
          <button type="button" class="btn btn-dark save-btn" @click="save('')">{{ $t("global.save") }}</button>
        </div>
      </template>
    </Modal>
    <Modal v-if="modalActive" v-on:closeModal="closeModalDelete">
      <template #header>
        <h6 class="modal-title">Eliminar Sincronización</h6>
      </template>
      <template>
        <p>¿Seguro que desea eliminar la Sincronización?</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-2" @click="closeModalDelete">{{
            $t("deleteAlert.cancel")
          }}</span>
          <button
            type="control button"
            class="btn btn-dark control delete-btn"
            @click="closeModalDelete"
          >
            {{ $t("deleteAlert.delete") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>

</template>

<script>
import API_SERVICE from "@/lib/api/userManagement";
import { ClientTable } from "vue-tables-2";
const Modal = () => import("@/components/Modal");
const api = new API_SERVICE();
export default {
  components: {
    ClientTable,
    Modal

  },
  methods: {
     getData:async function(){
      this.$store.commit("global/SET_LOADING", true);
    const resp = await api.getUsersV3();
    
    this.newsList=resp.items;
    
    this.$store.commit("global/SET_LOADING", false);

    },
    openEditModal: function (props) {
      console.log(props);
      
      const id=props.row.controlNumber;
      this.$router.push({
            name: 'Edit Synchronization',
            params: {
                id: id
            }
        })
    },
    openModal: function (props) {
      this.$router.push({
            name: 'View Synchronization',
            params: {
                id: props.row.controlNumber,
                type: 'visible'
            }
        })
    },
    closeModalDelete: function (id) {
      this.modalActive = false;
    },
    save:   function (type) { 
     
      
     

    },
    closeModal: function () {

      this.newModalActive = false;
    },
  },
  data: function () {
    return {
      textoError:"",
      valorTurno:{},
      error:false,
      titleData: "",
      type: "create",
      name: "",
      nameEdit: "",
      modalActive:false,
      newModalActive: false,
      newsList: [],
      modalActive: false,
      postToDelete: null,
      isLoading: false
    };
  },
  beforeMount: async function () {
    this.getData();
  },
  computed: {


    table_options: function () {
      return {

        columns: [
          "controlNumber","name","lastName","mothersLastName","status","actions"
        ],
        options: {
          filterByColumn: true,
          filterable: this.table_filters,
          texts: {
            filter: `${this.$t("components.vue_tables.filter")}:`,
            filterPlaceholder: this.$t("components.vue_tables.filter_ph")
          },
          headings: {
            controlNumber:"Número de control",
            name:"Nombre",
            lastName:"Apellido Paterno",
            mothersLastName:"Apellido Materno", 
            status:"Estatus",
            actions: "Acciones"
          },
          sortable: [
            "id",
            "name"
          ],
          customSorting: {
            report: function (ascending) {
              return function (a, b) {
                if (ascending) {
                  return !a.hasCommentsReported ? 1 : -1;
                }
                return a.hasCommentsReported ? 1 : -1;
              };
            }
          },
          filterable: [],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          columnsClasses: {
            title: "title-column",
            report: "report-column",
            actions: "actions-column",
            updated_at: "updatedAt-column"
          },
          resizableColumns: false
        }
      };
    },

  },
}
</script>

<style>
.alert-modal {
  width: 100%;
}
.controls {
  display: flex;
  margin-bottom: 30px;
  margin-top: 30px;

}

.controls .upload-btn {
  background-color: #000;
  border-radius: 0px;
  color: #fff;
  padding: 15px 13px;
}

.controls .upload-btn:hover {
  color: #fff;
}

.title {
  font-weight: bold;
  font-size: 1.2rem;
}

.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  >* {
    margin-left: 1rem;
    cursor: pointer;
  }

  .cancel-btn {
    &:hover {
      text-decoration: underline;
    }
  }

  .save-btn {
    margin: 0 0 0 10px;
    color: white;
    background-color: black;
    border-color: black;
    padding: 10px 20px;
    border-radius: 0px;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  }
}
</style>